import { render, staticRenderFns } from "./FormFilmTreatment.vue?vue&type=template&id=80ce7b8a&"
import script from "./FormFilmTreatment.vue?vue&type=script&lang=js&"
export * from "./FormFilmTreatment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports